// 登录组件

import { useState, useEffect } from 'react'
import { message, Form, Input, Button, Tag } from 'antd'
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import cookie from 'react-cookies'
import Test from '../test'
import logo_mini from './../../img/logo_mini.png'

function Login() {
  let [username, setUsernamer] = useState('')
  let [password, setPassword] = useState('')
  let [isLoading, setIsLoading] = useState(false)
  let [current_url, set_current_url] = useState(false)
  let [current_file_url, set_current_file_url] = useState('')
  let [upload_data, set_upload_data] = useState({ name: '', value: '', msg: '待上传' })//上传文件返回值  

  const handleSubmit = () => {
    if (isLoading) {
      return
    }
    if (username === '' || password === '') {
      alert('请填写账号和密码！')
      return
    }

    setIsLoading(true)
    fun['post_data'](url + 'admin_login', { '账号': username, '密码': password, is_xcx: false }).then(res => {
      if (res.status) {
        if (res.result['角色'] !== '管理员') {
          alert('角色异常')
        } else {
          message.success('登录成功！')
          cookie.save('login_id', res.result['id'], { path: '/' })
          cookie.save('session_key', res.result['session_key'], { path: '/' })
          cookie.save('login_username', res.result['账号'], { path: '/' })
          cookie.save('login_role', res.result['角色'], { path: '/' })
          setTimeout(() => {
            window.location.href = '/#/manager_client?t=' + (new Date()).getTime()
            window.location.reload()
          }, 500)
        }
      } else {
        alert('failed:' + JSON.stringify(res.result))
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    set_current_url(window.location.href.indexOf('test') !== -1)
  }, [])

  // return <div>
  // <h3 style={{}}>
  //   <input style={{}} onChange={(e: any) => {
  //     var file: any = e.target.files[0];
  //     fun.uploadFile({
  //       file,
  //       urlUpload: "https://zhenhongapi.seedsoftware.com.cn/newtrickle_upload_chunks",
  //       urlMerge: "https://zhenhongapi.seedsoftware.com.cn/newtrickle_merge_chunks",
  //     }, function (res: any) {
  //       // console.log(res)
  //       set_upload_data(res)
  //       if (res.name === 'ok') {
  //         if (res.value.msg === "文件上传成功") {
  //           let value = res.value.url
  //           set_current_file_url('https://zhenhongapi.seedsoftware.com.cn/' + value)
  //         } else {
  //           alert('文件上传失败：' + JSON.stringify(res.value))
  //         }
  //       }
  //     })
  //   }} type="file" />
  //   <Tag color={upload_data['name'] === 'ok' ? 'success' : 'processing'}>{upload_data['msg'] || '待上传'} {upload_data['name'] === 'upload' || upload_data['name'] === 'merge' ? (upload_data['value'] + '%') : ''}</Tag> 上传图片
  // </h3>
  //   <div>{current_file_url}</div>
  // </div>

  if (current_url) {
    return <Test />
  }

  return <div className='login_root_box'>
    <div className='login_root_box_in'>
      <div style={{}} className='login_root'>
        <div style={{ textAlign: 'center' }}>
          <h2 style={{ padding: '20px 0', fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ fontSize: 24, marginLeft: 15, color: '#1890ff', }}>开店工具盒小程序管理登录</span>
            {/* <img style={{ width: 65, height: 65, backgroundColor: '#ffffff', padding: 7, borderRadius: 10 }} src={logo_mini} /><span style={{ fontSize: 28, marginLeft: 15, color: '#825de0', }}>客户管理系统登陆</span> */}
          </h2>
        </div>
        <div style={{ width: 350, margin: '0 auto' }}>
          <Form onFinish={handleSubmit} className="login-form">
            <Form.Item>
              <Input
                size="large"
                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="账号"
                value={username}
                onChange={e => setUsernamer(e.target.value)}
              />
            </Form.Item>
            <Form.Item>
              <Input.Password
                size="large"
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                type="password"
                placeholder="密码"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </Form.Item>
            <Form.Item>
              <Button disabled={isLoading} style={{}} size="large" type="primary" htmlType="submit" className="login-form-button">{isLoading ? 'Loading...' : '登陆'}</Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  </div>
}
export default Login